import { apiClient } from "../../../api/client";
import * as ActionType from "./category.type";
import { setToast } from "../../../util/toast";

export const getCategory = () => async (dispatch) => {
  const res = await apiClient.get("category/getAllCategory");
  if (res.ok) {
    dispatch({ type: ActionType.GET_CATEGORY, payload: res.data?.categories });
  } else {
    console.log(res.message);
  }
};

export const createCategory = (data) => async (dispatch) => {
  const res = await apiClient.post("category/createCategory", data);
  if (res.ok && res.data?.status) {
    dispatch({ type: ActionType.CREATE_CATEGORY, payload: res.data?.category });
    setToast("success", "Category created successfully");
  } else {
    setToast("error", res.data?.message || res.message);
  }
};

export const updateCategory = (data) => async (dispatch) => {
  const res = await apiClient.patch("category/updateCategory", data);
  if (res.ok && res.data?.status) {
    dispatch({ type: ActionType.UPDATE_CATEGORY, payload: res.data?.category });
    setToast("success", "Category updated successfully");
  } else {
    setToast("error", res.data?.message || res.message);
  }
};

export const deleteCategory = (id) => async (dispatch) => {
  const res = await apiClient.delete(`category/deleteCategory?categoryId=${id}`);
  if (res.ok && res.data?.status) {
    dispatch({ type: ActionType.DELETE_CATEGORY, payload: id });
    setToast("success", "Category deleted successfully");
  } else {
    setToast("error", res.data?.message || res.message);
  }
};

export const getCategoryWiseSubCategory = (categoryId) => async (dispatch) => {
  const res = await apiClient.get(
    `subCategory/categoryWiseSubCategory?categoryId=${categoryId}`
  );
  if (res.ok) {
    dispatch({
      type: ActionType.GET_CATEGORY_WISE_SUBCATEGORY,
      payload: res.data?.subCategories,
    });
  } else {
    console.log(res.message);
  }
};
